module.exports = __webpack_public_path__ + "static/media/mockup.6f18341e.png";